import { FileText } from '@digital-twins/design-system/icons'

import { Text } from '@/components/ui/Text'

interface ThreadDocChipProps {
  title: string
  documentToken: string
  onOpen?: () => void
}

/**
 * Provenance chip for a `doc:<token>` markdown ref. Icon + title only —
 * never an embed of the source document.
 */
export function ThreadDocChip(props: ThreadDocChipProps) {
  const { title, documentToken, onOpen } = props

  return (
    <button
      type="button"
      data-testid="thread-doc-chip"
      data-document-token={documentToken}
      aria-label={title}
      className="inline-flex max-w-full items-center gap-1 rounded-md border border-border/60 bg-muted/40 px-1.5 py-0.5 align-middle text-left"
      onClick={(event) => {
        event.preventDefault()
        event.stopPropagation()
        onOpen?.()
      }}
    >
      <FileText
        className="h-3 w-3 shrink-0 text-muted-foreground"
        aria-hidden
      />
      <Text as="span" size="xs" className="truncate">
        {title}
      </Text>
    </button>
  )
}
